import React from 'react';
import './style.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import HeaderBannerCardsContent from './shared/content';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import clsx from 'clsx';

const HeaderBannerCards = (props) => {
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="HeaderBannerCards" />;
  const {
    heading,
    image, //required
    cardsImage,
    text,
    primaryButton,
    secondaryButton,
    link,
  } = props?.fields;

  return (
    <div className={clsx('header-banner-cards', 'add-margins', props?.params?.Styles)}>
      <div className="hbc-background">
        <Image field={image} className="hbc-background-image" />
      </div>
      <div className="content">
        <HeaderBannerCardsContent
          image={cardsImage}
          title={heading}
          text={text}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
          link={link}
        />
      </div>
    </div>
  );
};

export default HeaderBannerCards;
